import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose caller explains failures to the user itself, so
 * WizerHttpInterceptor does not also pop its generic error toast. Same effect
 * as the older `suppress-error-toast` header, without sending a custom header
 * to the server (which would need allow-listing in the CORS preflight).
 */
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
